import { ProgressBar } from '@plone/components';
import './styles.css';

function Loader() {
  return (
    <ProgressBar
      aria-label="Loading…"
      isIndeterminate
      className="loader"
      style={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <svg fill="none" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" />
        <path
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    </ProgressBar>
  );
}

export { Loader };
